/* jshint esversion: 11 */
/* jshint ignore:start */

import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { MyContext } from '../Context/MyProvider';
import { showTost } from '../showTost';

const Checkout = ({ Amount, ItemType, ItemId }) => {
  const { basUrl, page, setPayClose, setPlanId, setBuyCoin } = useContext(MyContext);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (!Amount || started) return;

    const startCheckout = async () => {
      setStarted(true);

      try {
        const localData = localStorage.getItem("Register_User");
        if (!localData) {
          throw new Error("Login required for payment.");
        }

        const userData = JSON.parse(localData);
        const itemType = ItemType || (page === "Upgrade" ? "plan" : page === "Wallet" ? "wallet" : "package");
        const itemId = ItemId || 0;
        const currentUrl = window.location.href.split("?")[0];

        const orderRes = await axios.post(`${basUrl}create_payment_order`, {
          uid: userData.id,
          item_type: itemType,
          item_id: itemId,
          amount: Amount,
          payment_gateway: "2checkout",
          customer_email: userData.email || "",
          customer_name: userData.name || "",
          customer_phone: userData.mobile || "",
          success_url: currentUrl,
          cancel_url: currentUrl,
        });

        if (orderRes.data.Result !== "true") {
          throw new Error(orderRes.data.ResponseMsg || "Unable to create 2Checkout checkout.");
        }

        if (!orderRes.data.checkout || !orderRes.data.checkout.url) {
          throw new Error("2Checkout checkout URL missing from backend.");
        }

        localStorage.setItem("2checkoutPendingPayment", JSON.stringify({
          order_id: orderRes.data.order_id,
          gateway_order_id: orderRes.data.checkout.gateway_order_id,
          item_type: itemType,
          item_id: itemId,
          amount: Amount,
          page,
        }));

        window.location.href = orderRes.data.checkout.url;
      } catch (err) {
        showTost({ title: err.message || "Unable to start 2Checkout payment." });
        if (page === "Upgrade") {
          setPlanId("PaymentNotDone");
        } else if (page === "Wallet") {
          setPayClose("PaymentNotDone");
        } else {
          setBuyCoin("PaymentNotDone");
        }
      }
    };

    startCheckout();
  }, [Amount, ItemId, ItemType, basUrl, page, setBuyCoin, setPayClose, setPlanId, started]);

  return (
    <div className="w-[100%] text-center py-[20px]">
      <h6 className="m-0">Redirecting to 2Checkout...</h6>
    </div>
  );
};

export default Checkout;
/* jshint ignore:end */
